import cloneDeep from 'lodash/cloneDeep';
import * as allTypes from '../mutation-type';
import * as types from './recommandation-mutation-type';
import getRecommandation from '@/services/recommandation/getRecommandation';
import { exportPdf, exportRecapPdf, exportExcel } from '@/api/recom/index';
import { browseClients } from '@/api/recom/index';
import PGetAllSecteurActiviteAsync from '@/api/secteurActivite';
import formatageConcurrents from '@/services/concurrent/concurrent';
import * as config from '@/configurations/clientConf';
import { RAYON_DEFAULT } from '@/configurations/configurationCarto';
import userConfig from '@/configurations/userConfig';
import gestionErreur from '@/services/general/gestionErreur';

function initialState() {
  return {
    response: {
      opportunite: {
        data: {
          pointDeVentes: [
            {}
          ]
        }
      }
    },
    solde: null,
    nbrSelect: 0,
    maSelection: false,
    rayon: RAYON_DEFAULT,
    concurrents: [],
    nbreConcurrents: 0,
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [allTypes.RESET_NOT_PERSISTED](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [types.SET_RESPONSE](state, response) {
    state.response = response;
  },
  ADD(state, data) {
    if (data) state.solde += data;
  },
  SUBSTRACT(state, data) {
    if (data) state.solde -= data; 
  },
  ADD_NBRSELECT(state) {
    state.nbrSelect += 1;
  },
  SUBSTRACT_NBRSELECT(state) {
    state.nbrSelect -= 1;
  },
  SELECTION(state, value) {
    state.maSelection = value;
  },
  [types.SET_FILTER_RAYON](state, rayon) {
    state.rayon = rayon;
  },
  [types.SET_CONCURRENTS](state, concurrents) {
    state.concurrents = concurrents;
  },
  [types.SET_NBRE_CONCURRENTS](state, nbreConcurrents) {
    state.nbreConcurrents = nbreConcurrents;
  },
};

const actions = {
  getRecom: async ({ commit}, id) => {
    const response = await getRecommandation(id);
    response.opportunite.data.pointDeVentes.forEach(pdv => {
      const panneauhono = pdv.panneaux.filter(p => ['FORFAIT HONORAIRES', 'honoraire'].includes(p.categorie.libelle));
      const panneaunormaux = pdv.panneaux.filter(p => !['FORFAIT HONORAIRES', 'honoraire'].includes(p.categorie.libelle)
    && (!response.opportunite.data.afficherPanneauxSousContrat ? p.ancienPanneau == "NON" : true));
      pdv.panneaux = panneaunormaux.concat(panneauhono)
      for (let index = 0; index < pdv.panneaux.length; index++) {
        const element = pdv.panneaux[index];
        element.num = index + 1
        if(element.echeanciers && element.echeanciers.some(ech => ech.id === '00000000-0000-0000-0000-000000000000')) {
          element.isEcheanceFictive = true;
        } else {
          element.isEcheanceFictive = false;
        }
        element.isNonRenouvelee = element.isNonRenouvelee === true;
      }
    })
    commit(types.SET_RESPONSE, cloneDeep(response));
    return response;
  },
  add(context, data) {
    context.commit('ADD', data);
  },
  substract(context, data) {
    context.commit('SUBSTRACT', data);
  },
  addNbSelect(context) {
    context.commit('ADD_NBRSELECT');
  },
  substractNbSelect(context) {
    context.commit('SUBSTRACT_NBRSELECT');
  },
  selection(context, value) {
    context.commit('SELECTION', value);
  },
  getPdfRecom: async (context, id) => {
    try {
      const resp = await exportPdf(id);
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(resp.data);
      const disposition = resp.request.getResponseHeader('Content-Disposition');
      link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
      link.click();
      return true;
    } catch (error) {
      return false;
    }
  },
  getRecapPdfRecom: async (context, id) => {
    try {
      const resp = await exportRecapPdf(id);
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(resp.data);
      const disposition = resp.request.getResponseHeader('Content-Disposition');
      link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
      link.click();
      return true;
    } catch (error) {
      return false;
    }
  },
  getRecapExcel: async (context, id) => {
    try {
      const resp = await exportExcel(id);
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(resp.data);
      const disposition = resp.request.getResponseHeader('Content-Disposition');
      link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
      link.click();
      return true;
    } catch (error) {
      return false;
    }
  },
  recupererConcurrents: async({ getters, commit, dispatch }) => {
    const pointDeVenteEnCours = cloneDeep(getters.pdv);
    const query = {
      type: config.TYPE_CLIENT,
      soustype: config.SOUS_TYPE_CONCURRENT,
      typologie: config.POINT_VENTE,
      rayon: getters.rayon,
      latitude: pointDeVenteEnCours.adresse.coordonnees.lat,
      longitude: pointDeVenteEnCours.adresse.coordonnees.lng,
      archive: false,
      societeId: getters.societeId,
    };
    try {
      userConfig.site = getters.societe.nom === "Havas" ? "havas" : "aa";
      await dispatch('user/logIn', userConfig, { root: true });
      const pdvs = (await browseClients(query)).data;
      const secteursActivites = (await PGetAllSecteurActiviteAsync()).data.result.items;
      const data = formatageConcurrents(pdvs, secteursActivites, pointDeVenteEnCours.secteurActiviteId);
      let nbreReelConcurrent = 0;
      data.forEach(el => {
        el.children.forEach(child => {
          if (child.children.length) nbreReelConcurrent += child.children.length;
          else nbreReelConcurrent += 1;
        })
      });
      commit(types.SET_CONCURRENTS, data);
      commit(types.SET_NBRE_CONCURRENTS, nbreReelConcurrent);
    } catch (e) {
      gestionErreur('Erreur lors de la récupération des concurrents', e);
    }
  },
};

const getters = {
  response: (state) => state.response,
  recom: (state) => state.response.opportunite,
  commercial: (state) => state.response.commercial,
  societe: (state) => state.response.societe,
  pdv: (state) => state.response.opportunite.data.pointDeVentes[0],
  panneaux: (state) => state.response.opportunite.data.pointDeVentes[0].panneaux,
  societeId: (state) => state.response.opportunite.data.societeId,
  getSolde: state => {
    return state.solde;
  },
  getNbrSelect: state => {
    return state.nbrSelect;
  },
  getMaSelection: state => {
    return state.maSelection;
  },
  rayon: (state) => {
    return state.rayon;
  },
  concurrents: (state) => {
    return state.concurrents;
  },
  nbreConcurrents: (state) => {
    return state.nbreConcurrents;
  },
  pdvConcurrentSelected: (state) => {
    const marques = state.concurrents
      .map(c => c.children).flat();
    const pdvs = marques
      .map(c => c.children).flat();
    return [
      ...pdvs,
      ...marques.filter(e => e.isPdv)
    ].filter(c => c.selected)
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
